import React from "react";
import { connect } from "react-redux";
import { Form, Row, Col, NavLink } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../layout/table";
import ConditionalButton from "../../layout/conditional-button";

import { send as pageInfo, loading } from "../../actions/page";
import { withNavigation } from "../../utils/wrapper";
import { search as getMatters } from "../../actions/matters";

class Matters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            search: "",
            order: "caption",
            index: 0,
            direction: "DESC",
            data: [],
            pages: 0,
            archived: 0,
            converted: 0,
            past: 0,
            active: 0
        };
        this.props.loading(true);
    }

    componentDidMount = () => {
        setTimeout(() => {
            this.loadData();
        }, 30);
    }


    loadData = async () => {
        this.props.loading(true);
        
        let { page, size, order, direction, search } = this.state;

        const __data = await this.props.getMatters({ page, size, order, direction, search });
        let __count = 0;

        if (__data?.items?.length > 0)
            __count = Math.ceil(Number(__data.count) / Number(size));

        this.setState({
            ...this.state,
            data: __data.items,
            pages: __count
        });
        

        await this.props.pageInfo({ title: `Matters`, breadcrumb: `Matters` });
        this.props.loading(false);
    }


    get headers() {
        return [
            {
                header: "Caption",
                sortable: true,
                source: "caption",
                className: "text-muted text-small text-uppercase w-35",
                onRender: this.onLinkFormat
            },
            {
                header: "Court",
                sortable: true,
                source: "uuid",
                className: "text-muted text-small text-uppercase w-25",
                onRender: this.onCourtLinkFormat
            },
            {
                header: "#",
                sortable: true,
                source: "caseNumber",
                className: "text-muted text-small text-uppercase w-20",
                onRender: this.onLinkFormat
            },
            {
                header: "Status",
                sortable: true,
                source: "status",
                className: "text-muted text-small text-uppercase w-20",
                onRender: this.onLinkFormat
            }
        ]
    }

    onCourtLinkFormat = (e, row) => {
        return (
            <NavLink role="button" to={`/dashboard/matters/${row?.uuid}`} >
                {row?.Court?.full ?? ""}
            </NavLink>);
    }

    onLinkFormat = (value, row) => (
        <a href={`/dashboard/matters/${row.uuid}`}>{value ?? ""}</a>
    );

    onColumnClick = (e) => {
        const __array = this.headers;
        const __index = __array.findIndex((item) => {
            return item.header === e.header && item.source === e.source;
        });

        this.setState({
            ...this.state,
            index: __index,
            direction: this.state.index === __index && this.state.direction === "DESC" ? "ASC" : "DESC",
            order: __array[__index].source,
            page: 0
        }, this.loadData);
    }

    onSearch = (e) => {
        this.setState({
            ...this.state,
            search: e
        }, this.loadData);
    }

    onSize = (e) => {
        this.setState({
            ...this.state,
            page: 0,
            size: Number(e)
        }, this.loadData);
    }

    onPageChange = (e) => {
        this.setState({
            ...this.state,
            page: Number(e)
        }, this.loadData);
    }

    onNewClick = (e) => {
        this.props.navigate("add");
    }

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Create new matter" display enabled={true} onEnabledClick={this.onNewClick} icon="flash">New</ConditionalButton>
                </Col>
                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        sort={{ index: this.state.index, direction: this.state.direction }}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                        onSearch={this.onSearch}
                        onSize={this.onSize}
                        searchable
                        sizable
                        filter={(
                            <Row className="mb-3">
                                <Col sm="12" md="6">
                                    <div className="d-inline-block">
                                        <Form.Check className="form-check float-end mt-1" type="checkbox" checked={this.state.past} onChange={this.onPastChange} />
                                        <Form.Label style={{marginLeft: "10px", marginTop: "6px", marginRight: "10px"}}>Include Past Matters</Form.Label>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    />
                </Col>
            </>
        )
    }
}

Matters.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth,
    });
};

export default withNavigation(connect(mapStateToProps, { loading, pageInfo, getMatters })(Matters));